import React from 'react';
import { OverflowMenu, OverflowMenuItem } from '@carbon/react';
import { CaretDown, Checkmark } from '@carbon/react/icons';
import styles from './version-switcher.module.scss';

interface Props<T> {
  items: T[];
  selectedItem: T;
  onChange: (item: T) => void;
  getItemKey: (item: T) => string;
  renderItemLabel: (item: T) => React.ReactNode;
  className?: string;
  menuClassName?: string;
  menuOptionsClassName?: string;
  ariaLabel?: string;
}

export function VersionSwitcher<T>({
  items,
  selectedItem,
  onChange,
  getItemKey,
  renderItemLabel,
  className,
  menuClassName = 'versionSwitcherMenu',
  menuOptionsClassName,
  ariaLabel = 'version-switcher-menu',
}: Props<T>) {
  return (
    <div
      className={`${styles.versionSwitcher} ${className || ''}`}
      data-testid="version-switcher"
    >
      <div>
        <span className={styles.selectedVersionLabel}>
          {renderItemLabel(selectedItem)}
        </span>
      </div>
      <OverflowMenu
        renderIcon={CaretDown}
        className={`${styles.versionSwitcherMenu} ${menuClassName || ''}`}
        menuOptionsClass={menuOptionsClassName}
        ariaLabel={ariaLabel}
      >
        {items.map((item) => {
          const key = getItemKey(item);
          const isSelected = getItemKey(selectedItem) === key;

          return (
            <OverflowMenuItem
              key={key}
              onClick={() => onChange(item)}
              className={isSelected ? styles.selectedMenuItem : styles.menuItem}
              itemText={
                <div className={styles.menuItemWrapper}>
                  <div className={styles.checkmarkContainer}>
                    {isSelected && <Checkmark />}
                  </div>
                  <div className={styles.menuItemLabel}>
                    {renderItemLabel(item)}
                  </div>
                </div>
              }
            />
          );
        })}
      </OverflowMenu>
    </div>
  );
}
